// src/frontend_react/src/components/navigation/AdminSidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import Stack from '../ui/Stack/Stack';
import Box from '../ui/Box/Box';
import Icon from '../ui/Icon/Icon';
import Typography from '../ui/Typography/Typography';
import styles from './Sidebar.module.css';

import {
  FiGrid,
  FiUsers,
  FiShield,
  FiBriefcase,
  FiDatabase,
  FiKey,
  FiClipboard,
  FiActivity,
  FiZap,
} from 'react-icons/fi';

const AdminSidebar = () => {
  const navItems = [
    { to: '/admin/dashboard/overview', label: 'Overview', icon: FiGrid },
    { to: '/admin/dashboard/users', label: 'User Management', icon: FiUsers },
    { to: '/admin/dashboard/roles', label: 'Role Management', icon: FiShield },
    {
      to: '/admin/dashboard/projects',
      label: 'Project Management',
      icon: FiBriefcase,
    },
    {
      to: '/admin/dashboard/datasourcetypes',
      label: 'Data Source Types',
      icon: FiDatabase,
    },
    { to: '/admin/dashboard/secrets', label: 'Secret Management', icon: FiKey },
    {
      to: '/admin/dashboard/mock-data',
      label: 'Mock Data Generator',
      icon: FiClipboard,
    },
    { to: '/user/workspace', label: 'Data Operations', icon: FiZap },
    { to: '/admin/dashboard/health', label: 'System Health', icon: FiActivity },
  ];

  return (
    <Box as="aside" className={styles.sidebar}>
      <Stack spacing="md" p="md" style={{ height: '100%' }}>
        <Box className={styles.sidebarHeaderTitleContainer} p="md" mb="md">
          <Typography
            variant="h5"
            component="h2"
            fontWeight="semibold"
            color="primary-text"
            align="left"
          >
            Admin Panel
          </Typography>
        </Box>
        <Box as="nav" aria-label="Admin Navigation" flexGrow={1}>
          {/* --- FIX: Ensure className is applied to the ul element --- */}
          <Stack as="ul" spacing="xs" className={styles.navList}>
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `${styles.navItem} ${isActive ? styles.active : ''}`
                  }
                  title={item.label}
                >
                  {item.icon && (
                    <Icon as={item.icon} className={styles.navIcon} size="lg" />
                  )}
                  <Typography
                    variant="body1"
                    component="span"
                    className={styles.navLabel}
                  >
                    {item.label}
                  </Typography>
                </NavLink>
              </li>
            ))}
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};
export default AdminSidebar;
